<!-- 商品操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :istitle="sendDataInfo.goodType==1 ? '器械操作记录' :sendDataInfo.goodType==2 ? '其他操作记录' : '商品操作记录'" :type="dataActionBox.actionType" :actionType="actionData.type" :activeName="showTabs" :name="'jciName'"
                        :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <!-- <el-tab-pane :label="" > -->
                            <div class="table_content_box" v-if="scope.index == -1">
                                <el-timeline v-if="reviewNodeList.length > 0">
                                    <el-timeline-item v-for="(nodeValue, nodeKey) in reviewNodeList" :key="nodeKey" :timestamp="$common.getLocalTime(nodeValue.createTime, true)" placement="top"
                                        :icon="nodeValue.auditId == null ? 'el-icon-close' : 'el-icon-check'" :type="nodeValue.auditId == null ? 'danger' : 'success'">
                                        <el-card v-if="nodeKey == 0">
                                            <h4>{{ nodeValue.appName }}</h4>
                                            <p>发起人：{{ nodeValue.orderCreaterName }}</p>
                                        </el-card>
                                        <el-card v-else>
                                            <h4>{{ nodeValue.nodeName }}</h4>
                                            <p>操作人：{{ nodeValue.opmName }}</p>
                                            <p v-if="nodeValue.auditState != null" :class="nodeValue.auditState == 0 ? 'auditing_text_red ' : 'auditing_text_green'">
                                                操作状态：{{ nodeValue.auditState == 0 ? '审核驳回' : '审核通过' }}
                                            </p>
                                            <p>审核意见：{{ nodeValue.auditRemark ? nodeValue.auditRemark : '暂无信息' }}</p>
                                        </el-card>
                                    </el-timeline-item>
                                </el-timeline>
                                <div v-else style="text-align:center">暂无数据</div>
                            </div>
                            <!-- </el-tab-pane> -->
                            <!-- 商品信息 -->
                            <div v-if="scope.index == 0">
                                <el-button v-if="extendShow" id="operateBtn" type="primary" size="small" class="btn" @click="openSearch(0, 0, 'bgiRegistno1')">提取授权注册证</el-button>
                                <el-button v-if="extendShow" id="operateBtn" type="primary" size="small" class="btn" @click="openSearch(0, 0, 'bgiBrand1')">提取授权品牌</el-button>
                                <el-form label-width="120px" class="baseForm" size="mini" :model="sendDataInfo" ref="sendDataInfo" :show-message="false"
                                    :disabled="dataActionBox.actionType >= 2 && dataActionBox.actionType != 7 && dataActionBox.actionType != 9 ? true : false">
                                    <el-row>
                                        <el-form-item v-if="formOneValue.isShow == 1" :label="formOneValue.showField" :id="formOneValue.entityField" :prop="formOneValue.entityField"
                                            v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []"
                                            :hide-required-asterisk="formOneValue.isRequired == 1 ? true : false">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                            <template>
                                                <el-tooltip class="item"
                                                    :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' || sendDataInfo[formOneValue.entityField].length <= 9 ? true : false"
                                                    effect="dark" :content="getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)" placement="bottom-start">
                                                    <!-- 库房 -->
                                                    <el-select filterable v-if="formOneValue.entityField == 'stId'" v-model="sendDataInfo[formOneValue.entityField]" clearable>
                                                        <el-option v-for="(storageRoomValue, storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" :value="storageRoomValue.stId">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 商品编码 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgmCode'" clearable v-model="sendDataInfo[formOneValue.entityField]"
                                                        :disabled="formOneValue.isChange == 0 || (formOneValue.isUpdate == 0 && dataActionBox.actionType >= 1)">
                                                        <el-button :disabled="formOneValue.isChange == 0 || (formOneValue.isUpdate == 0 && dataActionBox.actionType >= 1)" slot="append" @click="openCodePrefixDialog" type="primary"
                                                            size="mini">获取最新编号</el-button>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.fieldType == 'search'" clearable @clear="clear(formOneValue.setField, formOneValue.entityField)" v-model="sendDataInfo[formOneValue.entityField]"
                                                        :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                        :disabled="formOneValue.isChange == 0">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                            :disabled="formOneValue.isChange == 0">
                                                        </el-button>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'ggmInitunit'" clearable :disabled="formOneValue.isChange == 0" v-model="sendDataInfo.ggmInitunitName"
                                                        @focus="openSearch(formOneValue.searchId, 0, 'ggmInitunit')">
                                                    </el-input>
                                                    <!-- <df-date v-else-if="formOneValue.fieldType == 'date'" :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType==2" v-model="sendDataInfo[formOneValue.entityField]" /> -->

                                                    <!-- 备注 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgmRemarks'" type="textarea" clearable v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                                                    <!-- 手术类型 -->
                                                    <div class="cmContent" v-else-if="formOneValue.entityField == 'bgiSurgeryType'">
                                                        <el-button v-if="dataActionBox.actionType < 2" class="cmButton" @click="openRange('手术类型', 'bgiSurgeryType')" type="info" plain size="mini">选择手术类型</el-button>
                                                        <el-input type="textarea" v-model="obj.bgiSurgeryTypeNames" readonly>
                                                        </el-input>
                                                    </div>
                                                    <!-- 长 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMinilength'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 宽 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMiniwidth'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 高 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMiniheight'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 体积 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMinivolume'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">立方厘米（cm3）</template>
                                                    </el-input>
                                                    <!-- 重量 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMiniweight'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">克（g）</template>
                                                    </el-input>
                                                    <!-- 包装单位 -->
                                                    <el-select filterable clearable v-else-if="formOneValue.entityField == 'bgpUnitmeasurement'" v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in dictionariesData.BZDW" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 大包装 -->
                                                    <el-select filterable clearable v-else-if="formOneValue.entityField == 'largePackage'" v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in dictionariesData.DBZ" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 装箱规格 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'packingSpec'" @blur="number($event)" v-model.number="sendDataInfo[formOneValue.entityField]" type="number" min="0"
                                                        @keydown.up.native="increase" @keydown.down.native="decrease">
                                                    </el-input>

                                                    <!-- 编号分类 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'codeType'" filterable v-model="sendDataInfo[formOneValue.entityField]"
                                                        :disabled="formOneValue.isChange == 0||(formOneValue.isUpdate == 0&&dataActionBox.actionType!=0)">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in codeClassify" :key="dictionariesKey" :label="dictionariesValue.codeType" :value="dictionariesValue.codeType">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 养护类型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiCurtype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.yhlx" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 剂型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiDromodel'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue) in dictionariesData.jx" :key="dictionariesValue.diValue" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 处方类型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiPretype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cflx" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 质量标准 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiQuatype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.zlbz" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 产品线分类 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiLineClass'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in baseprolineList" :key="dictionariesKey" :label="dictionariesValue.bgiLineClass" :value="dictionariesValue.bgiLineClass">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 存储类型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiStocondition'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cctj" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 运输类型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'transMode'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.YSLX" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 剂型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiProrange'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.p" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 经营范围 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiManrange'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.m" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 诊疗范围 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiTrerange'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.z" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 集采分类 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'collectClassify'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.CJFL" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <el-cascader ref="cascader" :show-all-levels="false" :props="{ emitPath: false }" v-else-if="formOneValue.entityField == 'categoryName'" style="width: 100%;" :options="categoryList"
                                                        v-model="sendDataInfo[formOneValue.entityField]" @change="(value)=>{handleAddChange(value)}" clearable filterable>
                                                    </el-cascader>
                                                    <df-date v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"
                                                        :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 3 || dataActionBox.actionType == 4">
                                                    </df-date>
                                                    <!-- 是否冷藏 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'bgiIscoldstorage'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                    <!-- 是否唯一值 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'isOnly'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                    <!-- 是否双人验收 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'bgiIsdcheck'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>

                                                    <!-- 是否双人复核 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'bgiIsdreview'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>

                                                    <!-- 是否电子监管码 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'bgiIsesupervise'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                    <el-radio-group v-else-if="formOneValue.fieldType == 'radio'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button v-for="(item,index) in JSON.parse(formOneValue.formatterContent)" :key="index" :label="item.value">{{item.key}}</el-radio-button>
                                                    </el-radio-group>
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'dlType'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="cwflChange"
                                                        :disabled="formOneValue.isChange == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.DLLX" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                            :value="dictionariesValue.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 税务分类名称 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'taxname'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="taxChange"
                                                        :disabled="formOneValue.isChange == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.swflmc" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 财务分类名称 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'financialName'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="cwflChange"
                                                        :disabled="formOneValue.isChange == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cwfl" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                            :value="dictionariesValue.diValue"></el-option>
                                                    </el-select>
                                                    <el-input v-else-if="formOneValue.entityField == 'suggestedPrice'" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                        :disabled="formOneValue.isChange == 0" @input="validateInput('suggestedPrice')"></el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'lowestPrice'" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                        :disabled="formOneValue.isChange == 0" @input="validateInput('lowestPrice')"></el-input>

                                                    <el-input v-else-if="formOneValue.entityField == 'validPeriod'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0" @input="numInput(formOneValue.entityField)">
                                                        <template slot="append">个月</template>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'bgiMainfunction'" type="textarea" :maxlength="$store.state.inputLength" v-model="sendDataInfo[formOneValue.entityField]">
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'bgiQuanumber'" type="textarea" v-model="sendDataInfo[formOneValue.entityField]">
                                                    </el-input>
                                                    <el-select clearable size="mini" filterable v-else-if="formOneValue.entityField == 'bgiType'" @change="changesmIntype" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                                    </el-select>
                                                    <el-select clearable size="mini" filterable v-else-if="formOneValue.fieldType == 'formatter'" @change="((val) => { handleChange(val, formOneValue.entityField) })"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                                    </el-select>
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" @blur="blurChange(formOneValue.entityField)"></el-input>
                                                </el-tooltip>
                                            </template>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                            <div v-if="scope.index == 1">
                                <!-- 证照表格 -->
                                <el-form class="baseForm" :inline="true" size="mini">
                                    <div id="operateBtn" v-if="statecate == 0 || statecate == 1 || statecate == 9">
                                        <el-checkbox-group v-model="zzList" style="display: flex;align-items: center;flex-wrap: wrap;">
                                            <div v-for="(item, index) in licenseList" :key="index" style="width: 250px;padding-left: 15px;position: relative;">
                                                <span v-if="item.isBT == 1" style="color:red;" class="xing">*</span>
                                                <span v-if="item.isKX == 1" style="color:#409EFF;" class="xing">*</span>
                                                <el-checkbox style="width: 220px;" :label="item.diName"></el-checkbox>
                                            </div>
                                        </el-checkbox-group>
                                    </div>
                                    <el-table id="mxTable" :data="sendDataInfo.descibGoodLicenceAddList" border style="width: 100%" size='mini' :height="mxHeight">
                                        <el-table-column align="center" v-if="formOneValue.isShow == 1" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                            :show-overflow-tooltip="formOneValue.entityField == 'glUrl' ? false : true" :min-width="dealMinWidth(formOneValue.entityField)" :fixed="formOneValue.entityField == 'glUrl' ? 'right' : false">
                                            <template slot="header">
                                                <div>
                                                    <el-tooltip :content="formOneValue.showField" placement="top">
                                                        <div class="long_title"><span>{{ formOneValue.showField
														}}</span>
                                                        </div>
                                                    </el-tooltip>
                                                </div>
                                            </template>
                                            <template slot-scope="scope">
                                                <div v-if="dataActionBox.actionType == 2 || dataActionBox.actionType == 4">
                                                    <span v-if="formOneValue.isReserved == 1">
                                                        <span v-if="formOneValue.entityField == 'glTervalidity'">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField])
															}}
                                                        </span>
                                                        <span v-else-if="formOneValue.entityField == 'glRedate'">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField])
															}}
                                                        </span>
                                                        <span v-else-if="formOneValue.fieldType == 'date'">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField])
															}}
                                                        </span>
                                                        <div v-else-if="formOneValue.entityField == 'glUrl'" class="uploadList">
                                                            <cusImage class="image" v-for="(val, key) in scope.row.uploadVoList" :key="key" style="width: 30px; height: 30px;margin-top: 5px;" :src="val.url"
                                                                :preview-src-list="getUrl(scope.row.uploadVoList)">
                                                            </cusImage>
                                                        </div>
                                                        <span v-else-if="formOneValue.entityField == 'lityId'">{{
															scope.row[formOneValue.entityField] }}</span>
                                                        <span v-else-if="formOneValue.entityField == 'isUsed'">
                                                            <el-tag v-if="scope.row[formOneValue.entityField] == 1">是</el-tag>
                                                            <el-tag type="warning" v-else-if="scope.row[formOneValue.entityField] == 0">否</el-tag>
                                                        </span>
                                                        <span v-else-if="formOneValue.entityField == 'isIntercept'">
                                                            <el-tag v-if="scope.row[formOneValue.entityField] == 1">是</el-tag>
                                                            <el-tag type="warning" v-else-if="scope.row[formOneValue.entityField] == 0">否</el-tag>
                                                        </span>
                                                        <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                            <span v-if="formOneValue.formatterContent">
                                                                {{
																	$common.getIsGsp(formOneValue.formatterContent,
																		scope.row[formOneValue.entityField])
																}}
                                                            </span>
                                                        </span>
                                                        <span v-else>
                                                            {{ scope.row[formOneValue.entityField] }}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div v-else>
                                                    <div v-if="formOneValue.isReserved == 1">
                                                        <ul v-if="formOneValue.entityField == 'glUrl'" class="uploadList">
                                                            <li v-for="(val, key) in scope.row.uploadVoList" :key="key" class="image">
                                                                <i class="el-icon-error del" @click="delRemove(scope.$index, key)"></i>
                                                                <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="val.url" :preview-src-list="getUrl(scope.row.uploadVoList)">
                                                                </cusImage>
                                                            </li>
                                                        </ul>
                                                        <df-date :isType="true" v-else-if="formOneValue.entityField == 'glTervalidity'" v-model="sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]"
                                                            :isdisabled="formOneValue.isChange == 0">
                                                        </df-date>
                                                        <df-date :isType="true" :isShowLong="false" v-else-if="formOneValue.entityField == 'glRedate'" v-model="sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]"
                                                            :isdisabled="formOneValue.isChange == 0">
                                                        </df-date>
                                                        <df-date :isType="true" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]"
                                                            :isdisabled="formOneValue.isChange == 0"></df-date>
                                                        <!-- 证照类型 -->
                                                        <span v-else-if="formOneValue.entityField == 'lityId'">
                                                            {{
																sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]
															}}
                                                        </span>
                                                        <el-radio-group v-else-if="formOneValue.entityField == 'isUsed'" :disabled="formOneValue.isChange == 0"
                                                            v-model="sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]">
                                                            <el-radio-button label="0">否</el-radio-button>
                                                            <el-radio-button label="1">是</el-radio-button>
                                                        </el-radio-group>
                                                        <!-- 是否拦截 -->
                                                        <el-radio-group v-else-if="formOneValue.entityField == 'isIntercept'" :disabled="formOneValue.isChange == 0"
                                                            v-model="sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]">
                                                            <el-radio-button label="0">否</el-radio-button>
                                                            <el-radio-button label="1">是</el-radio-button>
                                                        </el-radio-group>

                                                        <!-- 备注 -->

                                                        <el-input v-else-if="formOneValue.entityField == 'glTernumber'" v-model.trim="sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]"
                                                            :maxlength="$store.state.inputLength">
                                                            <template slot="append"><span style="color: red;">{{
																sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]
																	== '' ||
																	sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]
																	== null ||
																	sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]
																	== undefined ? 0 :
																	sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField].length
															}}位</span></template>
                                                        </el-input>
                                                        <el-input v-else v-model="sendDataInfo.descibGoodLicenceAddList[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    </div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" :width="printScanShow?430:350" v-if="dataActionBox.actionType != 2 && dataActionBox.actionType != 4">
                                            <template slot-scope="scope">
                                                <input style="display: none;" type="file" id="recordExcel" accept="image/*" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                                <label for="recordExcel" class="image_label" @click="eventIndex = scope.$index">上传</label>
                                                <el-button type="primary" @click="showUploadDialog(scope.$index)">拖拽上传</el-button>
                                                <el-button @click.stop="openFile1(0), eventIndex = scope.$index" type="primary" size="mini">高拍仪</el-button>
                                                <el-button v-if="printScanShow" @click.stop="openFile1(1), eventIndex = scope.$index" type="primary" size="mini">扫描仪</el-button>
                                                <el-button @click="deleteDetails(scope.row)" type="danger" size="mini">删除</el-button>
                                                <el-button type="primary" size="mini" @click="copyClick(scope.row)">复制</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form>
                            </div>
                            <!-- 价格策略 -->
                            <div v-if="scope.index == 2">
                                <el-table ref="tables" size='mini' border :data="sendDataInfo.dempBusgoodpriceList">
                                    <el-table-column v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :ref="formOneValue.entityField" :prop="formOneValue.entityField" :label="formOneValue.showField"
                                        show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                        <template slot-scope="scope" v-if="formOneValue.isReserved == 0">
                                            <el-switch v-if="formOneValue.entityField == 'priceType'" v-model="sendDataInfo.dempBusgoodpriceList[scope.$index].priceType" active-text="按折扣" inactive-text="按价格"
                                                @change="v => refreshTable(v, scope.$index)" :disabled="dataActionBox.actionType >= 2 && dataActionBox.actionType != 7 ? true : false"></el-switch>
                                            <template v-else-if="formOneValue.entityField == 'levleDiscount'">
                                                <input :class="['oldInput', !sendDataInfo.dempBusgoodpriceList[scope.$index].priceType ? 'oldDisabled' : '']"
                                                    :disabled="!sendDataInfo.dempBusgoodpriceList[scope.$index].priceType || (dataActionBox.actionType >= 2 && dataActionBox.actionType != 7)" type="text" min="0"
                                                    v-model="sendDataInfo.dempBusgoodpriceList[scope.$index].levleDiscount" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');if(value<0)value='';" />
                                                %
                                            </template>
                                            <template v-else-if="formOneValue.entityField == 'levlePrice'">
                                                <input @blur="blur(scope.$index)" :class="['oldInput', sendDataInfo.dempBusgoodpriceList[scope.$index].priceType ? 'oldDisabled' : '']"
                                                    :disabled="sendDataInfo.dempBusgoodpriceList[scope.$index].priceType || (dataActionBox.actionType >= 2 && dataActionBox.actionType != 7)" type="number" min="0"
                                                    v-model.number="sendDataInfo.dempBusgoodpriceList[scope.$index].levlePrice" />
                                            </template>
                                            <div v-else-if="formOneValue.entityField == 'levleName'">
                                                <span v-for="(item, index) in priceResData" :key="index">
                                                    <span v-if="item.levleId == scope.row.levleId">
                                                        {{ item.levleName }}
                                                    </span>
                                                </span>
                                            </div>
                                            <div v-else>
                                                {{ scope.row[formOneValue.entityField] }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="" v-if="dataActionBox.actionType == 4 || (dataActionBox.actionType == 1 && actionData.type == '审核修改')" style="margin-top:20px;margin-bottom:60px;">
                    <el-form :model="taskData" label-width="130px" size="mini" v-if="dataActionBox.actionType == 4 || (dataActionBox.actionType == 1 && actionData.type == '审核修改')">
                        <el-form-item label="审批结果">
                            <el-radio-group v-model="taskData.auditState">
                                <el-radio-button :label="1">同意</el-radio-button>
                                <el-radio-button :label="0">不同意</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="审批意见" prop="auditRemark" :rules="[{ required: auditRemarkRequired, message: '请输入审批意见', trigger: ['blur', 'change'] }]">
                            <el-input type="textarea" placeholder="请输入内容" v-model="taskData.auditRemark" maxlength="200" show-word-limit>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="foot">
                    <div v-if="actionData.type == '审核修改'">
                        <span style="color:red;font-size: 18px;margin-right: 10px;" v-if="message">{{ message }}</span>
                        <el-button v-if="$common.checkIsPrint()" type="primary" @click="showPrintPlan">查看</el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')">{{ sendDataInfo.goodType==1 ? '器械修改审核' :sendDataInfo.goodType==2 ? '其他修改审核' :
							'商品修改审核'
						}}</el-button>
                    </div>
                    <div v-else>
                        <span style="color:red;font-size: 18px;margin-right: 10px;" v-if="message">{{ message }}</span>
                        <el-button v-if="(dataActionBox.actionType == 2 || dataActionBox.actionType == 4) && $common.checkIsPrint()" type="primary" @click="showPrintPlan">{{ dataActionBox.actionType == 4 ? '查看' : '打印' }}</el-button>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="printImg(sendDataInfo.descibGoodLicenceAddList)">批量打印</el-button>
                        <el-button v-if="dataActionBox.actionType != 2" type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 9 || dataActionBox.actionType == 0 || dataActionBox.actionType == 7">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
                        <el-button type="primary" v-if="dataActionBox.actionType == 3" @click="submitData()">{{ sendDataInfo.goodType==1 ? '提交器械信息' :sendDataInfo.goodType==2 ? '提交其他信息' :'提交商品信息' }}</el-button>
                        <el-button type="primary" v-if="dataActionBox.actionType == 4" @click="submitDataAction()">{{sendDataInfo.goodType==1 ? '器械提交审核' :sendDataInfo.goodType==2 ? '其他提交审核' :'商品提交审核' }}</el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :parentSearchData="parentSearchData" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="instrumentFlag" :visible.sync="instrumentFlag" width="70%" :modal-append-to-body='true' :append-to-body="true" top="20px">
            <bgiRegistnoAction v-if="seType == 'bgiRegistno'" ref="bgiRegistnoAction" @TranData="bgiBrandClick">
            </bgiRegistnoAction>
            <authorizeRegistnoAction v-else-if="seType == 'bgiRegistno1'" ref="authorizeRegistnoAction" @TranData="bgiBrandClick">
            </authorizeRegistnoAction>
            <bgiBrandAction v-else-if="seType == 'bgiBrand'" ref="bgiBrandAction" @TranData="bgiBrandClick">
            </bgiBrandAction>
            <manufacturerAction v-else-if="seType == 'manufacturer'" ref="manufacturerAction" @TranData="bgiBrandClick">
            </manufacturerAction>
            <authorizeBrandAction v-else-if="seType == 'bgiBrand1'" ref="authorizeBrandAction" @TranData="bgiBrandClick">
            </authorizeBrandAction>
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true" :before-close="showClose">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showClose">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 高拍仪 -->
        <FileNewAction ref="FileNewAction" v-if="showFile" :showFile="showFile" uploadType="zz" @isshowFile="IsshowFile" @NewelectFileIds="changeFileIds"></FileNewAction>
        <!-- 扫描仪 -->
        <el-dialog title="扫描仪上传" destroy-on-close :visible.sync="scanShow" width="80%" append-to-body top="20px">
            <scannerPlugin v-if="scanShow" ref="scannerPlugin" uploadType="zz" @submit="scanOnSubmit"></scannerPlugin>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 范围穿梭框 -->
        <el-dialog :title="'选择' + rangeTitle" :visible.sync="dialogRange" width="70%" :modal-append-to-body='true' id="csDia" :append-to-body="true" :before-close="handleClose">
            <div class="edit_dev">
                <el-transfer filterable v-if="dialogRange" target-order="push" :filter-method="filterMethod" filter-placeholder="请输入范围名称" v-model="rangeValue" :titles="['未选择', '已选择']" :data="transferData">
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="confirmRange">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编号前缀选择弹窗 -->
        <el-dialog title="选择编号前缀" :visible.sync="codePrefixDialogVisible" width="600px" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="codePrefixList" border style="width: 100%" highlight-current-row @current-change="handleCodePrefixSelect" @row-dblclick="handleRowDoubleClick">
                <el-table-column prop="pre" label="编号前缀" width="200"></el-table-column>
                <el-table-column prop="maxCode" label="最大编号" width="200"></el-table-column>
                <el-table-column label="下一个编号" width="200">
                    <template slot-scope="scope">
                        {{ scope.row.pre + (parseInt(scope.row.maxCode.replace(scope.row.pre, '')) +
							1).toString().padStart(scope.row.maxCode.replace(scope.row.pre, '').length, '0') }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="codePrefixDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmCodePrefix" :disabled="!selectedCodePrefix">确定</el-button>
            </span>
        </el-dialog>
        <DragUpload ref="dragUpload" title="文件上传" :multiple="true" :limit="100" uploadType="zz" @confirm="onUploadConfirm" />
    </div>
</template>

<script>
import print from 'vue-print-nb'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import bgiRegistnoAction from "@/components/bgiRegistnoAction.vue";
import bgiBrandAction from "@/components/bgiBrandAction.vue";
import authorizeRegistnoAction from "@/components/authorizeRegistnoAction.vue";
import authorizeBrandAction from "@/components/authorizeBrandAction.vue";
import manufacturerAction from "@/components/manufacturerAction.vue";
export default {
    name: "firstGoodsAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        bgiRegistnoAction,
        bgiBrandAction,
        authorizeRegistnoAction,
        authorizeBrandAction,
        manufacturerAction,
    },
    data() {
        //这里存放数据
        return {
            categoryList: [],
            extendShow: window.global_config.extendShow ? true : false,
            auditRemarkRequired: window.global_config.auditRemarkRequired,
            diaContract: false, //合同
            showFile: false,
            token: {
                token: sessionStorage.getItem("token"),
            },
            dataActionBoxdigion: false,
            requesUrl: "",
            imgUrl: "",
            fileData: [],
            // 审核信息
            taskData: {
                auditState: 0,
                auditRemark: "",
                businessId: "",
            },
            reviewNodeList: [],
            selectDataTable: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            rulesList: [],
            formKey: 2,
            dialogRange: false,
            bgiSurgeryTypeList: [],
            bgiSurgeryTypeIds: [],
            rangeValue: "",
            transferData: [],
            rangeTitle: "",
            rangeNum: "",
            obj: {
                bgiSurgeryTypeNames: "",
            },
            sendDataInfo: {
                packingSpec: "",
                riskLevel: "",
                descibGoodLicenceAddList: [],
                barcode: "",
                manufacturer: "",
                mne: "",
                bgmName: "",
                placeorigin: "",
                bgmRemarks: "",
                bgmSpecifications: "",
                spec: "",

                bgfIntaxrate: 0,
                bgfOuttaxrate: 0,
                taxname: "", //税务名称
                taxnumber: "", //税务编码
                financialName: "", //财务分类名称
                financialCode: "", //财务分类编码
                inRate: "",
                outRate: "",
                goodFinanceReserves1: "",
                goodFinanceReserves2: "",
                goodFinanceReserves3: "",
                goodFinanceReserves4: "",
                goodFinanceReserves5: "",
                goodFinanceReserves6: "",
                validPeriod: "",
                lowestPrice: "",//最低售价
                suggestedPrice: "", //建议售价
                serialNumber: "",
                // busgoodfinance: {

                // },
                bgpUnitmeasurement: "",
                bgiAppnumber: "",
                bgiAppvalidity: 0,
                bgiBrand: "",
                bgiCurcycle: "",
                bgiCurtype: "",
                bgiDromodel: "",
                bgiGename: "",
                bgiIscoldstorage: 0,
                bgiIsdcheck: 0,
                bgiIsdreview: 0,
                bgiIsesupervise: 0,
                bgiKrecordno: "",
                bgiKrvalidity: 0,
                bgiLonumber: "",
                bgiMainfunction: "",
                bgiManrange: "",
                bgiPerholder: "",
                bgiPretype: "",
                bgiProlicense: "",
                bgiProrange: "",
                bgiProvalidity: 0,
                bgiQuanumber: "",
                bgiQuatype: "",
                bgiRegistno: "",
                bgiRegistvalidity: 0,
                bgiStocondition: "", //存储类型
                storageMode: "", //存储条件
                bgiTrerange: "",
                bgiType: "",
                goodIndustryReserves1: "",
                goodIndustryReserves2: "",
                goodIndustryReserves3: "",
                goodIndustryReserves4: "",
                goodIndustryReserves5: "",
                goodIndustryReserves6: "",
                // busgoodindustry: {

                // },
                largePackage: "", //大包装
                bgpColor: "",
                bgpMiniheight: "",
                bgpMinilength: "",
                bgpMinivolume: "",
                bgpMiniweight: "",
                bgpMiniwidth: "",
                bgpSituation: "",
                bgpUnitmeasurement: "",
                goodPackingReserves1: "",
                goodPackingReserves2: "",
                goodPackingReserves3: "",
                goodPackingReserves4: "",
                goodPackingReserves5: "",
                goodPackingReserves6: "",
                // busgoodpacking: {

                // },
                dempBusgoodpriceList: [],
                ggmInitunit: "",
                goodReserves1: "",
                goodReserves2: "",
                goodReserves3: "",
                goodReserves4: "",
                goodReserves5: "",
                goodReserves6: "",
                stId: "",
                fileNumber: "", //档案编号
                goodAttributes1: "", //业务属性
                goodAttributes2: "", //业务属性
                goodAttributes3: "", //业务属性
                goodType: "", //药品类型0.药品1.器械
                state: "",
                inRate: "",
                outRate: ""
            },
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            licenseList: {},
            userOneList: [],
            goodsList: [],
            storageRoomList: [],
            swArr: [],
            midPriceData: [
                {
                    priceType: false,
                    levleDiscount: 0,
                    levlePrice: 0,
                    levleId: 0,
                    levleName: "",
                    bgcId: 0,
                },
            ],
            priceResData: [],
            selectedDetailsIndex: 0, //选择索引
            dialogVisible: false,
            dialogImageUrl: "",
            addpushlist: {
                glTername: "", //证照名称
                glTernumber: "",
                glReoffice: "",
                glTervalidity: "",
                glRedate: "",
                uploadVoList: [], //附件
                lityId: "",
                isIntercept: "1",
                isUsed: "1",
                remark: "", //备注
            },
            fileList: [],
            uploadVoList: [],
            fileIdlist: [],
            seTitle: "",
            seWidth: "",
            exWidth: "",
            seType: "",
            DialogVisible: false,
            rangeObj: {}, //范围对象
            componentType: false, //判断父级false首营,true业务商品
            mxHeight: 0, //表格动态高度
            isLoaded: false,
            tabForm: [],
            mxForm: [],
            footForm: [],
            sField: "",
            isQixie: false, //goodType  //药品类型0.药品1.器械
            view1_mode_list: [],
            view1_resolution_list: [],
            img_base64List: [],
            view1_mode_selected: '1',
            view1_resolution_selected: '',
            selectFileIds: [],
            type: 1,
            watchZZInfo: true,
            dialogList: [],
            showDialog: false,
            showStatus: -1,
            message: "",//提示语
            codeClassify: '',//编号分类
            zzList: [],
            print: {
                id: 'imgs',
                popTitle: 'erp', // 打印配置页上方的标题
                extraHead: 'erp', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
                preview: true, // 是否启动预览模式，默认是false
                previewTitle: 'erp', // 打印预览的标题
                previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
                zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
                previewBeforeOpenCallback() { console.log('正在加载预览窗口！'); console.log(that.msg, this) }, // 预览窗口打开之前的callback
                previewOpenCallback() { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
                beforeOpenCallback() { console.log('开始打印之前！') }, // 开始打印之前的callback
                openCallback() { console.log('执行打印了！') }, // 调用打印时的callback
                closeCallback() { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
                clickMounted() { console.log('点击v-print绑定的按钮了！') },
                standard: '',
                extarCss: '',
            },
            ruleData: [],
            // 编号前缀弹窗相关数据
            codePrefixDialogVisible: false,
            codePrefixList: [],
            selectedCodePrefix: null,
            //--------------
            instrumentFlag: false,
            baseprolineList: [],
            parentSearchData: {},
            //---------扫描仪上传
            scanShow: false,
            printScanShow: false,
        };
    },
    directives: {
        print
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.bgmName": {
            handler: function (newValue, oldValue) {
                if ((this.dataActionBox.boxTitle != '编辑首营商品信息' && this.dataActionBox.boxTitle != '编辑商品信息') || this.type != 1) {
                    if (this.dataActionBox.actionType == 0 || this.dataActionBox.actionType == 9 || this.dataActionBox.actionType == 1) {//修改商品名称助记码跟着变（傲联）
                        this.sendDataInfo.mne =
                            this.$common.createPinyinCode(newValue, this.sendDataInfo.mne);
                    }
                }
                this.type++
                this.productVerify()
            },
            deep: true,
        },
        "sendDataInfo.spec": {
            handler: function (newValue, oldValue) {
                this.productVerify()
            },
            deep: true
        },
        "sendDataInfo.manufacturer": {
            handler: function (newValue, oldValue) {
                this.productVerify()
            },
            deep: true
        },
        "sendDataInfo.bgpSituation": {
            handler: function (newValue, oldValue) {
                this.productVerify()
            },
            deep: true
        },
        "addpushlist.glTervalidity": {
            handler: function (newValue, oldValue) {
                if (this.watchZZInfo) {
                    this.$nextTick(() => {
                        if (newValue == '' || newValue == 0.5) {
                            return
                        }
                        let data = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
                        if (newValue <= data) {
                            if (newValue.length < 4) {
                                this.addpushlist.glTervalidity = ''
                            } else {
                                this.$confirm('确定要使用吗？有效期已过！', '警告', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'error'
                                }).then(() => {

                                }).catch(() => {
                                    this.addpushlist.glTervalidity = ''

                                });
                            }

                        }
                        if (newValue > data && (data + 30 * 24 * 60 * 60 * 1000) > newValue) {
                            this.$confirm('确定要使用吗？剩余有效期30天以内！', '提醒', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {

                            }).catch(() => {
                                this.addpushlist.glTervalidity = ''
                            });
                        }
                    })
                } else {
                    this.watchZZInfo = true
                }
            },
            deep: true,
        },
        zzList: {
            deep: true,
            handler(nvl, ovl) {
                let arr = [...nvl]
                this.sendDataInfo.descibGoodLicenceAddList = this.sendDataInfo.descibGoodLicenceAddList.filter(item => {
                    if (nvl.includes(item.lityId)) {
                        arr.splice(arr.findIndex(items => items == item.lityId), 1)
                        return true
                    } else {
                        return false
                    }
                })
                this.sendDataInfo.descibGoodLicenceAddList.forEach((item, index) => {
                    item.uploadVoList.map(items => {
                        items.url = this.imgUrl + "/" + items.fileUrl
                        items.name = items.fileName
                        return items
                    })
                })
                this.$nextTick(() => {
                    arr.forEach(item => {
                        this.sendDataInfo.descibGoodLicenceAddList.push({
                            glTername: item, //证照名称
                            sliTername: "",
                            glTernumber: "",
                            glReoffice: "",
                            glTervalidity: "",
                            glRedate: "",
                            uploadVoList: [], //附件
                            lityId: item,
                            isIntercept: "1",
                            isUsed: "1",
                            remark: "", //备注
                        })
                        var index = this.sendDataInfo.descibGoodLicenceAddList.length - 1
                        this.lityChange(item, index)
                    })
                })

            }
        },
        "sendDataInfo.descibGoodLicenceAddList": {
            handler: function (newValue, oldValue) {
                newValue.forEach(item => {
                    if (item.glRedate && item.glRedate != 0.5 && item.glTervalidity && item.glTervalidity != 0.5 && item.glTervalidity < item.glRedate) {
                        this.$message.error("有效期不能小于办证日期")
                        item.glTervalidity = 0.5
                    }
                })
            },
            deep: true
        }
    },
    //方法集合
    methods: {
        OCRResult(list) {
            if (Array.isArray(list)) {
                var arr = list.filter(item => item.name == "说明书")
                if (arr.length > 0) {
                    arr.forEach(item => {
                        if (item.result) {
                            Object.keys(this.sendDataInfo).forEach(key => {
                                if (!this.sendDataInfo[key]) {
                                    if (item.result[key]) {
                                        this.sendDataInfo[key] = item.result[key]
                                    }
                                }
                            })
                        }
                    })
                }
                list.forEach(item => {
                    if (item.result) {
                        Object.keys(this.sendDataInfo).forEach(key => {
                            if (!this.sendDataInfo[key]) {
                                if (item.result[key]) {
                                    this.sendDataInfo[key] = item.result[key]
                                }
                            }
                        })
                    }
                    if (this.zzList.filter(item1 => item1 == item.name).length == 0) {
                        this.sendDataInfo.descibGoodLicenceAddList.push({
                            glTername: item.name, //证照名称
                            glTernumber: item.result1.glTernumber,
                            glReoffice: item.result1.glReoffice,
                            glTervalidity: item.result1.glTervalidity,
                            glRedate: item.result1.glRedate,
                            uploadVoList: item.uploadVoList, //附件
                            lityId: item.name,
                            isIntercept: "1",
                            isUsed: "1",
                            remark: "", //备注
                        })
                        this.zzList.push(item.name)
                    } else {
                        let index = this.zzList.findIndex(item1 => item1 == item.name)
                        this.sendDataInfo.descibGoodLicenceAddList[index].uploadVoList.push(...item.uploadVoList)
                    }
                })
                this.$nextTick(() => {
                    if (list.length > 0) {
                        this.$refs["sendDataInfo"].validate();
                    }
                })
            }
        },
        showUploadDialog(index) {
            this.eventIndex = index
            this.$refs.dragUpload.open();
        },
        onUploadConfirm(files) {
            console.log('上传的文件:', files);
            files.forEach(item => {
                this.sendDataInfo.descibGoodLicenceAddList[this.eventIndex].uploadVoList.push({
                    fileUrl: item.fileUrl,
                    url: this.imgUrl + "/" + item.fileUrl,
                    fileName: item.fileName,
                    fileId: item.fileId,
                    fileType: this.sendDataInfo.descibGoodLicenceAddList[this.eventIndex].lityId,
                })
            })
        },
        handleAddChange(value) {
            setTimeout(() => {
                var node = this.$refs['cascader'][0].getCheckedNodes()[0]
                if (!node) {
                    this.sendDataInfo.categoryCode = ""
                    return
                }
                this.sendDataInfo.categoryCode = node.data.pathCode
            }, 100)
        },
        getUrl(list) {
            return list.map(val => val.url)
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'stId') {
                if (this.storageRoomList) {
                    this.storageRoomList.forEach(item => {
                        if (item.stId == val) {
                            str = item.stName
                        }
                    })
                }
            } else if (type == 'dlType') {
                if (this.dictionariesData.DLLX) {
                    this.dictionariesData.DLLX.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiLineClass') {
                if (this.baseprolineList) {
                    this.baseprolineList.forEach(item => {
                        if (item.bgiLineClass == val) {
                            str = item.bgiLineClass
                        }
                    })
                }
            } else if (type == 'bgpUnitmeasurement') {
                if (this.dictionariesData.BZDW) {
                    this.dictionariesData.BZDW.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'collectClassify') {
                if (this.dictionariesData.CJFL) {
                    this.dictionariesData.CJFL.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'largePackage') {
                if (this.dictionariesData.DBZ) {
                    this.dictionariesData.DBZ.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiCurtype') {
                if (this.dictionariesData.yhlx) {
                    this.dictionariesData.yhlx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiDromodel') {
                if (this.dictionariesData.jx) {
                    this.dictionariesData.jx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiPretype') {
                if (this.dictionariesData.cflx) {
                    this.dictionariesData.cflx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiQuatype') {
                if (this.dictionariesData.zlbz) {
                    this.dictionariesData.zlbz.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiStocondition') {
                if (this.dictionariesData.cctj) {
                    this.dictionariesData.cctj.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'transMode') {
                if (this.dictionariesData.YSLX) {
                    this.dictionariesData.YSLX.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiProrange') {
                if (this.rangeObj.p) {
                    this.rangeObj.p.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'bgiManrange') {
                if (this.rangeObj.m) {
                    this.rangeObj.m.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'bgiTrerange') {
                if (this.rangeObj.z) {
                    this.rangeObj.z.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'financialName') {
                if (this.dictionariesData.cwfl) {
                    this.dictionariesData.cwfl.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        //手术类型
        // 打开选择范围
        openRange(title, type) {
            this.rangeValue = [];
            this.transferData = [];
            this.rangeTitle = title;
            if (type == "bgiSurgeryType") {
                this.rangeNum = 1;
                if (this.bgiSurgeryTypeIds.length > 0) {
                    this.rangeValue = this.bgiSurgeryTypeIds.map(Number);
                }
                this.bgiSurgeryTypeList.forEach((item) => {
                    this.transferData.push({
                        label: item.surgeryName,
                        key: item.id,
                        pinyin: item.surgeryCode,
                    });
                });
            }
            this.dialogRange = true;
        },
        // 过滤方法
        filterMethod(query, item) {
            console.log(item);
            if (query != '') {
                if (/^[a-zA-Z]*$/.test(query)) {
                    // alert("“" + str + "”里全是字母！");
                    return item.pinyin.indexOf(query) > -1;
                }
                else if (/^[\u4e00-\u9fa5]*$/.test(query)) {
                    // alert("“" + str + "”里全是汉字！");
                    return item.label.indexOf(query) > -1;
                }
            }
            return item.pinyin.indexOf(query) > -1;
        },
        // 选择范围确定
        confirmRange() {
            if (this.rangeNum == 1) {
                this.bgiSurgeryTypeIds = this.rangeValue; //手术类型
                const idSet = new Set(this.bgiSurgeryTypeIds.map(String));
                const value1 = [];
                if (this.bgiSurgeryTypeList && this.bgiSurgeryTypeList.length > 0) {
                    this.bgiSurgeryTypeList.forEach(item => {
                        if (idSet.has(String(item.id))) {
                            value1.push(item.surgeryName);
                        }
                    });
                }
                this.obj.bgiSurgeryTypeNames = value1.join(',');
            }
            this.dialogRange = false;
        },
        // 是否确认关闭
        handleClose(done) {
            this.$confirm("关闭弹窗将删除已选择的范围，确认关闭？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dialogRange = false;
                })
                .catch(() => { });
        },
        dealMinWidth(field) {
            if (field == 'glReoffice' || field == 'glTervalidity' || field == 'glRedate' || field == 'glTernumber' || field == 'glTername' || field == 'lityId') {
                return '200'
            } else if (field == 'glUrl') {
                return '230'
            } else {
                return '100'
            }
        },
        increase(event) {
            // 阻止默认行为
            event.preventDefault();
        },
        decrease(event) {
            event.preventDefault();
        },
        numInput(entityField) {
            console.log(this.sendDataInfo[entityField]);
            var str = JSON.parse(JSON.stringify(this.sendDataInfo[entityField]))
            var arr = str.split("")
            const regex = /^\d+(\.\d+)?$/;
            if (!regex.test(str)) {
                arr.forEach((item, index) => {
                    if (!regex.test(str[index]) && item != ".") {
                        arr.splice(index, 1)
                    }
                })
            }
            var strText = ""
            arr.forEach(item => {
                strText = strText + item
            })
            this.sendDataInfo[entityField] = strText
        },
        //可输入(小数或整数)
        validateInput(entityField) {
            // 正则表达式匹配整数或小数
            const regex = /^\d+(\.\d+)?$/;
            // 检查输入值是否匹配正则表达式
            if (!regex.test(this.sendDataInfo[entityField])) {
                // 如果不匹配，则替换掉非法字符，只保留数字和小数点
                this.sendDataInfo[entityField] = this.sendDataInfo[entityField].replace(/[^\d.]/g, '');
                // 如果需要，可以在这里添加逻辑来定位光标到最后一个合法字符之后
            } else {
            }
            if (String(this.sendDataInfo[entityField]).indexOf(".") != -1) {
                var strNum = String(this.sendDataInfo[entityField]).indexOf(".")
                if (String(this.sendDataInfo[entityField]).length - 1 - strNum > 10) {
                    this.sendDataInfo[entityField] = this.$common.getDecimalInfo(2, this.sendDataInfo[entityField])
                }
            }
        },
        confirmPrintImgs() {
            this.$print(document.getElementById('imgs'))
        },
        print() {
            this.$print(document.getElementById('prr'))
        },
        printImg(list) {
            this.fileData = []
            list.forEach(item => {
                item.uploadVoList.forEach(e => {
                    if (e.fileUrl != '' && e.fileUrl) {
                        this.fileData.push({
                            flag: "",
                            fileUrl: window.global_config.BASE_IMG_URL + '/' + e.fileUrl
                        })
                    }
                })
            })

            // 等待所有图片加载完成后打开打印窗口
            this.loadAllImagesAndPrint()
        },

        // 加载所有图片并进行打印
        loadAllImagesAndPrint() {
            let loadedCount = 0;
            const totalCount = this.fileData.length;

            if (totalCount === 0) {
                this.$message.warning('没有找到可打印的图片');
                return;
            }

            this.fileData.forEach((item, index) => {
                const img = new Image();
                img.src = item.fileUrl;

                img.onload = () => {
                    loadedCount++;

                    // 判断图片方向
                    if (img.width > img.height) {
                        item.flag = true;
                    } else {
                        item.flag = false;
                    }

                    // 当所有图片都处理完成后打开打印窗口
                    if (loadedCount === totalCount) {
                        this.openPrintWindow();
                    }
                };

                img.onerror = () => {
                    loadedCount++;
                    console.error(`Failed to load image: ${item.fileUrl}`);

                    // 即使某些图片加载失败也尝试打印
                    if (loadedCount === totalCount) {
                        this.openPrintWindow();
                    }
                };
            });
        },

        // 打开打印窗口
        openPrintWindow() {
            let imgsHtml = '';

            this.fileData.forEach(item => {
                const src = item.fileUrl;
                if (item.flag) {
                    // 横向图片
                    imgsHtml += `
                        <div style="width:210mm;height:297mm;display:flex;align-items:center;justify-content:center;page-break-after:always;overflow:hidden;">
                            <img src='${src}' style="transform:rotate(90deg);width:297mm;height:210mm;object-fit:contain;display:block;" />
                        </div>`;
                } else {
                    // 纵向图片
                    imgsHtml += `
                        <div style="width:210mm;height:297mm;display:flex;align-items:center;justify-content:center;page-break-after:always;overflow:hidden;">
                            <img src='${src}' style="width:210mm;height:297mm;object-fit:contain;display:block;" />
                        </div>`;
                }
            });

            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
                <html>
                <head>
                    <title>证照批量打印</title>
                    <style>
                        @page { size: A4; margin: 0; }
                        html, body { width: 210mm; height: 297mm; margin: 0; padding: 0; }
                        img { width: 100%; height: 100%; object-fit: contain; display: block; margin: 0 auto; }
                        .page-break { 
                            display: block; 
                            page-break-before: always; 
                        }
                    </style>
                </head>
                <body>
                    ${imgsHtml}
                    <script>
                        function closeWindow() {
                            window.close();
                        }
                        function printAndClose() {
                            window.print();
                            setTimeout(closeWindow, 500);
                        }
                        window.onload = function() {
                            // 延迟执行，确保图片完全加载
                            setTimeout(printAndClose, 500);
                        }
                    <\/script>
                </body>
                </html>
            `);
            printWindow.document.close();
        },
        //商品验证
        productVerify() {
            var bgmName = ""
            var spec = ""
            var manufacturer = ""
            var bgpSituation = ""
            if (this.sendDataInfo.bgmName) {
                bgmName = this.sendDataInfo.bgmName.replace(/\s/g, "")
            } else if (this.sendDataInfo.spec) {
                spec = this.sendDataInfo.spec.replace(/\s/g, "")
            } else if (this.sendDataInfo.manufacturer) {
                manufacturer = this.sendDataInfo.manufacturer.replace(/\s/g, "")
            } else if (this.sendDataInfo.bgpSituation) {
                bgpSituation = this.sendDataInfo.bgpSituation.replace(/\s/g, "")
            }
            if (window.global_config.bgpSituationShow) {
                if (spec != "" && bgmName != "" && manufacturer != "" && bgpSituation != "") {
                    this.verify()
                }
            } else {
                if (spec != "" && bgmName != "" && manufacturer != "") {
                    this.verify()
                }
            }

        },
        async verify() {
            const params = {
                "bgmId": "",
                "manufacturer": "",
                "name": "",
                "spec": "",
                "bgpSituation": ""
            }
            for (const key in params) {
                if (key == 'name') {
                    params[key] = this.sendDataInfo.bgmName
                } else if (this.sendDataInfo[key]) {
                    params[key] = this.sendDataInfo[key]
                } else {
                    params[key] = ""
                }
            }
            const responseData = await this.$http.GSPgoodscheckRepeatGoods(params)
            if (responseData.status == 300) {
                this.message = responseData.message
            } else {
                this.message = ""
            }
        },
        blurs(index) {
            this.sendDataInfo[index] = this.$common.getDecimalInfo(2, this.sendDataInfo[index])
        },
        blur(index) {
            this.sendDataInfo.dempBusgoodpriceList[index].levlePrice = this.$common.getDecimalInfo(2, this.sendDataInfo.dempBusgoodpriceList[index].levlePrice)
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        IsshowFile(value) {
            this.showFile = value
            console.log(this.showFile)
        },
        changeFileIds(val) {
            this.sendDataInfo.descibGoodLicenceAddList[this.eventIndex].uploadVoList = [...this.sendDataInfo.descibGoodLicenceAddList[this.eventIndex].uploadVoList, ...val]
            this.showFile = false
        },
        //  打开文件上传组件
        openFile1(val) {
            if (val == 1) {
                this.scanShow = true
            } else {
                this.showFile = true
            }
        },
        // 扫描仪上传
        scanOnSubmit(val) {
            const currentLicence = this.sendDataInfo.descibGoodLicenceAddList[this.eventIndex]
            const fileType = currentLicence.lityId

            // 转换文件数据
            const list = val.map(item => ({
                fileUrl: item.fileUrl,
                url: `${this.imgUrl}/${item.fileUrl}`,
                fileName: item.fileName,
                fileId: item.fileId,
                fileType
            }))

            // 确保 uploadVoList 存在
            if (!currentLicence.uploadVoList) {
                currentLicence.uploadVoList = []
            }

            // 添加新文件
            currentLicence.uploadVoList = [...currentLicence.uploadVoList, ...list]
            this.scanShow = false
        },
        setFormatter(key, optionsStr) {
            var opArr = optionsStr ? JSON.parse(optionsStr) : [];
            if (Array.isArray(opArr)) {
                if (opArr.length > 0) {
                    this.sendDataInfo[key] = opArr[0].value;
                    return opArr;
                }
            } else {
                opArr = [];
                return opArr;
            }
        },
        // 下拉赋值
        handleChange(value, name) {
            this.sendDataInfo[name] = value;
            if (name == 'isExpi') {
                var arr = this.tabForm.filter(item => item.jciId == 1077687)
                if (this.sendDataInfo[name] == 1) {
                    arr[0].jurconfigform.forEach(item => {
                        if (item.entityField == 'validPeriod') {
                            item.isRequired = 1
                        }
                    })
                } else {
                    arr[0].jurconfigform.forEach(item => {
                        if (item.entityField == 'validPeriod') {
                            item.isRequired = 0
                        }
                    })
                }
            }

        },
        number(e) {
            let flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);
            if (!flag) {
                this.$message({
                    showClose: true,
                    message: "请输入正整数",
                    type: "warning",
                });
                return;
            }
        },
        //税务名称改变
        taxChange(data) {
            console.log("data", data);
            for (let i = 0; i < this.dictionariesData.swflmc.length; i++) {
                const item = this.dictionariesData.swflmc[i];
                if (item.diName == data) {
                    this.sendDataInfo.taxnumber = item.diCode;
                    break;
                }
            }
        },
        //税务名称改变
        cwflChange(data) {
            for (let i = 0; i < this.dictionariesData.cwfl.length; i++) {
                const item = this.dictionariesData.cwfl[i];
                if (item.diName == data) {
                    this.sendDataInfo.financialCode = item.diCode;
                    break;
                }
            }
        },
        async showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                if (this.dataActionBox.actionType == 4 || this.actionData.type == '审核修改') {
                    let responseData = await this.$http.getPenetrateData({ ids: [this.actionData.orderId] })
                    console.log(responseData);
                    if (responseData.status == 200) {
                        var res = responseData.result
                        // 选中的数据
                        this.$refs.printPlan.openDia(
                            this.actionData.orderId,
                            res.printSource,
                            res.jurId,
                            'oper'
                        );
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: 'error'
                        });
                    }
                } else {
                    // 选中的数据
                    this.$refs.printPlan.openDia(
                        this.actionData.orderId,
                        this.actionData.printSouce,
                        this.actionData.printJurId
                    );
                }
            } else {
                return;
            }
        },
        //证照选择变化
        lityChange(data, index) {
            if (this.ruleData.length == 0) {
                return
            }
            var flag = false
            this.ruleData.forEach(item => {
                if (item.license.indexOf(data) != -1 && !flag) {
                    flag = true
                    this.sendDataInfo.descibGoodLicenceAddList[index].glTernumber = this.sendDataInfo[item.field]
                }
            })
            // if (!flag) {
            // this.sendDataInfo.descibGoodLicenceAddList[index].glTernumber = ''
            // }
            // this.sendDataInfo.descibGoodLicenceAddList[index].glTername = data;
        },
        blurChange(type) {
            if (type == 'bgiRegistno' || type == 'bgiAppnumber' || type == 'bgiProlicense') {
                this.sendDataInfo.descibGoodLicenceAddList.forEach((item, index) => {
                    this.lityChange(item.glTername, index)
                })
            }
        },
        //根据赋值字段 清除赋值字段的值
        clear(sField, type) {
            if (type == 'bgmName') {
                if (this.dataActionBox.actionType != 9) {
                    this.sendDataInfo.barcode = "";
                    this.sendDataInfo.spec = "";
                    this.sendDataInfo.manufacturer = "";
                    this.sendDataInfo.placeorigin = "";
                    this.sendDataInfo.bgiAppnumber = "";
                    this.sendDataInfo.bgiPerholder = "";
                    this.sendDataInfo.bgiProlicense = "";
                    this.sendDataInfo.storageMode = "";
                    this.sendDataInfo.bgpUnitmeasurement = "";
                    this.sendDataInfo.packingSpec = "";
                } else {
                    this.sendDataInfo.bgmName = "";
                    this.sendDataInfo.bgmId = "";
                }
                return
            }
            if (sField) {
                var sField = sField.split(',')
                for (const key in this.sendDataInfo) {
                    sField.forEach(item => {
                        if (key == item) {
                            this.sendDataInfo[key] = ""
                        }
                    })
                }

            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            console.log(type, "测试");

            this.seType = type;
            if (type == 'bgiRegistno' || type == 'manufacturer' || type == 'bgiBrand' || type == 'bgiRegistno1' || type == 'bgiBrand1') {
                this.instrumentFlag = true;
                this.seTitle = type == 'bgiRegistno' ? '注册证信息' : type == 'bgiBrand' ? '品牌信息' : type == 'bgiRegistno1' ? '授权注册证信息' : type == 'bgiBrand1' ? '授权品牌' : type == 'manufacturer' ? '生产厂商信息' : ''
            } else {
                this.DialogVisible = true;
                this.seId = sId;
                this.seIndex = index;
                this.sField = sField;
            }
            if (type == 'ggmInitunitName') {
                this.parentSearchData.smName = this.sendDataInfo[type]
            } else if (type == 'bgiRegistno1') {
                this.parentSearchData.bgiRegistno = this.sendDataInfo.bgiRegistno
            } else {
                this.parentSearchData[type] = this.sendDataInfo[type]
            }
        },
        bgiBrandClick(val) {
            console.log('返回', val);

            if (this.seType == 'bgiBrand') {
                // 只有当字段为空时才赋值
                if (!this.sendDataInfo.manufacturer) {
                    this.sendDataInfo.manufacturer = val.row.manufacturer
                }
                if (!this.sendDataInfo.bgiProlicense) {
                    this.sendDataInfo.bgiProlicense = val.row.bgiProlicense
                }
                this.sendDataInfo.bgiBrand = val.row.bgiBrand
            } else if (this.seType == 'manufacturer') {
                this.sendDataInfo.manufacturer = val.row.manufacturer
                if (!this.sendDataInfo.bgiProlicense) {
                    this.sendDataInfo.bgiProlicense = val.row.bgiProlicense
                }
            } else {
                this.sendDataInfo.bgiRegistno = val.row.bgiRegistno
                this.sendDataInfo.bgiLineClass = val.row.bgiLineClass
                this.sendDataInfo.bgiManrange = String(val.row.bgiManrange)
                this.sendDataInfo.instrumentType = val.row.bgiManrangeName
            }
            var mx = val.detailsList
            mx.forEach(item => {
                // 按 lityId 判断是否已存在，存在则先删除再添加
                const existIndex = this.sendDataInfo.descibGoodLicenceAddList.findIndex(v => v.lityId == item.lityId)
                if (existIndex > -1) {
                    this.sendDataInfo.descibGoodLicenceAddList.splice(existIndex, 1)
                }
                this.sendDataInfo.descibGoodLicenceAddList.push({
                    glTername: item.glTername, //证照名称
                    sliTername: "",
                    glTernumber: item.glTernumber,//证照号
                    glReoffice: "",
                    glTervalidity: item.glTervalidity,
                    glRedate: item.glRedate,
                    uploadVoList: item.glUrl, //附件
                    lityId: item.lityId,
                    isIntercept: "1",
                    isUsed: "1",
                    remark: "", //备注
                })
            })
            this.zzList = this.sendDataInfo.descibGoodLicenceAddList.map(item => item.lityId)
            this.instrumentFlag = false
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.$set(this.sendDataInfo, item, val[item]);
            });
        },
        changeInputModel(val) {
            console.log("返回", val);
            console.log("返回", this.seType);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == "ggmInitunit") {
                    this.sendDataInfo.ggmInitunit = val.smId;
                    this.sendDataInfo.ggmInitunitName = val.smName;
                } else if (this.seType == "bgmName") {
                    for (const key in val) {
                        if (key == 'bgiManrange' || key == 'bgiProrange') {
                            if (val[key] != "" && val[key] != null && val[key] != undefined) {
                                this.$set(this.sendDataInfo, key, val[key])
                            } else {
                                this.$set(this.sendDataInfo, key, '')
                            }
                        } else if (key == 'riskLevel') {
                            let num = val[key]
                            this.$set(this.sendDataInfo, key, isNaN(num) ? "" : num)
                        } else if (key == 'bgiIsesupervise') {
                            if (val[key] == null || val[key] == '' || val[key] == undefined) {
                                this.$set(this.sendDataInfo, key, 0)
                            } else {
                                this.$set(this.sendDataInfo, key, val[key])
                            }
                        } else {
                            this.$set(this.sendDataInfo, key, val[key])
                        }

                    }
                } else if (this.seType == "manufacturer") {
                    this.getManufacturer(val)
                } else {
                    this.paramValue(val);
                }
            }
        },
        getManufacturer(val) {
            this.sendDataInfo.manufacturer = val.manufacturer
            this.sendDataInfo.bgiProlicense = val.bgiProlicense

        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },

        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item.fileUrl);
            });
            return imgList;
        },

        //获取生产/经营范围
        async getQueryScopeByType(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByTypeByOrm(params);
            if (responseData.status == 200) {
                return responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取诊疗范围
        async getQueryScopeByTypeZhenLiao(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByType(params);
            if (responseData.status == 200) {
                return responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 将字典类字段的中文名称转换为 ID
        convertDictFieldsToId() {
            let needRefresh = false

            // 生产范围 bgiProrange -> rangeObj.p
            if (this.sendDataInfo.bgiProrange && this.rangeObj.p && this.rangeObj.p.length > 0) {
                const found = this.rangeObj.p.find(item => item.scopeName === this.sendDataInfo.bgiProrange)
                if (found) {
                    this.$set(this.sendDataInfo, 'bgiProrange', String(found.discId))
                    this.$set(this.sendDataInfo, 'bgiProrangeName', found.scopeName)
                } else {
                    // 如果没有找到对应的 ID，清空该字段
                    console.log(`生产范围 "${this.sendDataInfo.bgiProrange}" 未找到对应的 ID，已清空`)
                    this.sendDataInfo.bgiProrange = ''
                    this.sendDataInfo.bgiProrangeName = ''
                    needRefresh = true
                }
            }

            // 经营范围 bgiManrange -> rangeObj.m
            if (this.sendDataInfo.bgiManrange && this.rangeObj.m && this.rangeObj.m.length > 0) {
                const found = this.rangeObj.m.find(item => item.scopeName === this.sendDataInfo.bgiManrange)
                console.log(found, 'found2222222222222')
                if (found) {
                    this.$set(this.sendDataInfo, 'bgiManrange', String(found.discId))
                    this.$set(this.sendDataInfo, 'bgiManrangeName', found.scopeName)
                } else {
                    // 如果没有找到对应的 ID，清空该字段
                    console.log(`经营范围 "${this.sendDataInfo.bgiManrange}" 未找到对应的 ID，已清空`)
                    this.sendDataInfo.bgiManrange = ''
                    this.sendDataInfo.bgiManrangeName = ''
                    needRefresh = true
                }
            }

            // 诊疗范围 bgiTrerange -> rangeObj.z
            if (this.sendDataInfo.bgiTrerange && this.rangeObj.z && this.rangeObj.z.length > 0) {
                const found = this.rangeObj.z.find(item => item.scopeName === this.sendDataInfo.bgiTrerange)
                console.log(found, 'found3333333333333')
                if (found) {
                    this.$set(this.sendDataInfo, 'bgiTrerange', String(found.discId))
                    this.$set(this.sendDataInfo, 'bgiTrerangeName', found.scopeName)
                } else {
                    // 如果没有找到对应的 ID，清空该字段
                    console.log(`诊疗范围 "${this.sendDataInfo.bgiTrerange}" 未找到对应的 ID，已清空`)
                    this.sendDataInfo.bgiTrerange = ''
                    this.sendDataInfo.bgiTrerangeName = ''
                    needRefresh = true
                }
            }

            // 如果有字段被清空，强制刷新视图
            if (needRefresh) {
                this.$forceUpdate()
            }

            console.log(this.sendDataInfo, this.rangeObj, 'sendDataInfo11111111111')
        },
        delRemove(index, key) {
            this.eventIndex = index
            this.sendDataInfo.descibGoodLicenceAddList[this.eventIndex].uploadVoList.splice(key, 1)
        },
        async fileUpload(files, length, index, e) {
            console.log(files);
            if (length - 1 >= index) {
                const params = {
                    type: 'zz',
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                console.log(response);
                if (response.status == 200) {
                    this.sendDataInfo.descibGoodLicenceAddList[this.eventIndex].uploadVoList.push({
                        fileUrl: response.result[0].fileUrl,
                        url: this.imgUrl + "/" + response.result[0].fileUrl,
                        fileName: response.result[0].fileName,
                        fileId: response.result[0].fileId,
                        fileType: this.sendDataInfo.descibGoodLicenceAddList[this.eventIndex].lityId,
                    })
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        pushDefaultValue(type) {    // 器械表单默认值
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (item.entityField == 'inRate' || item.entityField == 'outRate') {
                    if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                        this[type][item.entityField] = item.defaultValue;
                    }
                }
            });
        },
        // 默认值
        initDefaultValue(type) {
            let arr = this.formDataList[1].jurconfigform;
            arr.forEach((item) => {
                if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                    this[type][item.entityField] = item.defaultValue;
                }
            });
            this[type].uploadVoList = [];
        },
        //复制一行
        copyClick(row) {
            this.sendDataInfo.descibGoodLicenceAddList.push(JSON.parse(JSON.stringify(row)))
        },
        //删除明细
        deleteDetails(row) {
            this.selectedDetailsIndex = this.sendDataInfo.descibGoodLicenceAddList.indexOf(row)
            if (this.sendDataInfo.descibGoodLicenceAddList.length < 1) {
                this.$message({
                    message: "请先添加",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.descibGoodLicenceAddList.splice(
                this.selectedDetailsIndex,
                1
            );
            this.zzList = this.sendDataInfo.descibGoodLicenceAddList.map(item => {
                return item.lityId
            })
            this.selectedDetailsIndex = 0;
        },
        cancellist(addpushlist) {
            if (this.dataActionBox.boxTitle == "新增") {
                for (const key in this.addpushlist) {
                    this.addpushlist[key] = ""
                }
                this.addpushlist.isIntercept = "1"
                this.addpushlist.isUsed = "1"
                this.addpushlist.uploadVoList = []
            }
            this.dataActionBoxdigion = false;
        },
        refreshTable(v, index) {
            // if (v) {
            //   this.sendDataInfo.dempBusgoodpriceList[index].levlePrice = 0;
            // } else {
            //   this.sendDataInfo.dempBusgoodpriceList[index].levleDiscount = 0;
            // }
            this.sendDataInfo.dempBusgoodpriceList.splice(1, 0);
        },
        // 获取任务审核历史
        async getTaskReviewHistory(id) {
            if (!id) return;
            let responseData = await this.$http.getTaskReviewHistory({
                ids: [id],
            });
            if (responseData.status == 200) {
                this.reviewNodeList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 提交审核
        submitDataAction() {
            if (this.auditRemarkRequired && !this.taskData.auditRemark) {
                this.$message({
                    message: "请输入审批意见",
                    type: "warning",
                });
                return;
            }
            this.$confirm("确定要提交审核?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.addTaskReview(this.taskData);
                    console.log(responseData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });
                        this.$emit("drawerCancel", true);
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        // 提交审核
        submitData() {
            if (!this.sendDataInfo.ggmId) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = JSON.parse(JSON.stringify(this.sendDataInfo));
            this.$confirm("确定要提交审核吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.ggmId],
                    };
                    let responseData = await this.$http.submitFirstGoods(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.$emit("drawerCancel", true);
                        this.$refs["addpushlist"].resetFields();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        initActionBox() {
            // if (this.dataActionBox.actionType != 0 || this.dataActionBox.actionType != 1) return this.$emit(
            // 	"drawerCancel");
            if (this.dataActionBox.actionType != 5 && this.actionData.type != '审核修改') {
                this.$confirm(
                    "确定取消" + this.dataActionBox.boxTitle + "吗?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.$emit("drawerCancel");
                        // this.dataActionBox.showStatus = false
                        // this.init()
                    })
                    .catch(() => { });
            } else {
                this.$emit("drawerCancel");
            }
        },
        init() {
            for (let key in this.sendDataInfo) {
                switch (key) {
                    case "descibGoodLicenceAddList": // 证照
                        this.sendDataInfo.descibGoodLicenceAddList = [];
                        break;
                    default:
                    // this.sendDataInfo[key] = "";
                }
            }
        },
        clearSendData(data) {
            for (let key in data) {
                data[key] = "";
            }

            return data;
        },

        async isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.psomBuycus = dataInfo.smId;
                        this.sendDataInfo.smName = dataInfo.smName;
                    }
                    break;
                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId;
                        this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName;
                    }
                    break;
            }
        },
        isNull(value) {
            if (value != undefined && value != 0 && value != '') {
                return true;
            } else {
                return false;
            }
        },
        //获取列表
        openBox() {
            this.getQueryCodeClassifyaArr()
            this.printScanShow = window.global_config.printScanShow ? true : false
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.statecate = this.actionData.cate;
            this.componentType = this.actionData.fatherType; //父级类型
            this.filterMainField()
            this.getPriceList().then(() => {
                this.dataActionBox.showStatus = true;
                console.log(this.dataActionBox.actionType)
                if (this.dataActionBox.actionType == 0) {//器械
                    this.showTabs = this.actionData.formData[0].jciName;
                    if (this.isQixie == 1) { //器械
                        // this.pushDefaultValue('sendDataInfo')
                        this.dataActionBox.boxTitle = this.componentType ? "新增器械信息" : "新增首营器械信息";  //false首营
                    } else {
                        this.dataActionBox.boxTitle = this.componentType ? "新增商品信息" : "新增首营商品信息";
                    }
                    this.dataActionBox.openMode = "ltr";
                    this.sendDataInfo.dempBusgoodpriceList = [];
                    this.priceResData.forEach((v) => {
                        this.sendDataInfo.dempBusgoodpriceList.push({
                            levleId: v.levleId,
                            levleDiscount: 0,
                            levlePrice: 0,
                            priceType: false,
                        });
                    });

                    this.actionData.formData[0].jurconfigform.forEach(item => {
                        if (item.entityField == 'codeType' && item.defaultValue != '' && item.defaultValue != null && item.defaultValue != undefined) {
                            this.sendDataInfo.codeType = item.defaultValue
                        }
                    })
                } else if (this.dataActionBox.actionType == 2) {
                    this.dataActionBox.boxTitle = "查看信息";
                    var dataInfo = JSON.parse(JSON.stringify(oldData));
                    for (let key in dataInfo) {
                        this.$set(this.sendDataInfo, key, dataInfo[key])
                        if (key == 'descibGoodLicenceAddList') {
                            if (dataInfo[key]) {
                                this.zzList = dataInfo[key].map(item => item.lityId)
                                // 初始化 isIntercept 和 isUsed 字段，如果为 null 则设置默认值 '1'
                                dataInfo[key].forEach(item => {
                                    if (item.isIntercept === null || item.isIntercept === undefined || item.isIntercept === "") {
                                        this.$set(item, 'isIntercept', "1");
                                    }
                                    if (item.isUsed === null || item.isUsed === undefined || item.isUsed === "") {
                                        this.$set(item, 'isUsed', "1");
                                    }
                                })
                            }
                        }
                    }
                    if (this.sendDataInfo.bgiSurgeryType != undefined && this.sendDataInfo.bgiSurgeryType != null) {
                        this.bgiSurgeryTypeIds = this.sendDataInfo.bgiSurgeryType.split(",")
                    } else {
                        this.bgiSurgeryTypeIds = []
                    }
                    this.sendDataInfo.dempBusgoodpriceList && this.sendDataInfo.dempBusgoodpriceList.forEach(v => v.priceType = v.priceType == 1 ? true : false)
                    if (this.sendDataInfo.validPeriod != '') this.sendDataInfo.validPeriod = this.sendDataInfo.validPeriod.split('个月')[0]
                } else {
                    this.dataActionBox.openMode = "rtl";
                    !this.componentType && this.getTaskReviewHistory(oldData.ggmId);
                    var dataInfo = JSON.parse(JSON.stringify(oldData));
                    for (let key in dataInfo) {
                        this.$set(this.sendDataInfo, key, dataInfo[key])
                        if (key == 'descibGoodLicenceAddList') {
                            if (dataInfo[key]) {
                                this.zzList = dataInfo[key].map(item => item.lityId)
                                // 初始化 isIntercept 和 isUsed 字段，如果为 null 则设置默认值 '1'
                                dataInfo[key].forEach(item => {
                                    if (item.isIntercept === null || item.isIntercept === undefined || item.isIntercept === "") {
                                        this.$set(item, 'isIntercept', "1");
                                    }
                                    if (item.isUsed === null || item.isUsed === undefined || item.isUsed === "") {
                                        this.$set(item, 'isUsed', "1");
                                    }
                                })

                            }
                        }
                    }
                    if (this.actionData.type == '审核修改') {
                        this.taskData.auditState = 1;
                        this.taskData.auditRemark = "";
                        this.taskData.businessId = [oldData.ggmId];
                    }
                    if (this.sendDataInfo.bgiSurgeryType != undefined && this.sendDataInfo.bgiSurgeryType != null && this.sendDataInfo.bgiSurgeryType != "") {
                        console.log(this.sendDataInfo.bgiSurgeryType.split(","), "测试");
                        this.bgiSurgeryTypeIds = this.sendDataInfo.bgiSurgeryType.split(",")
                    } else {
                        console.log(123);
                        this.bgiSurgeryTypeIds = []
                    }
                    if (this.dataActionBox.actionType == 7) {
                        this.sendDataInfo.fileNumber = ""
                        // 复制新增时，确保 radio 类型字段有正确的默认值
                        if (this.sendDataInfo.bgiIsesupervise === undefined || this.sendDataInfo.bgiIsesupervise === null || this.sendDataInfo.bgiIsesupervise === '') {
                            this.$set(this.sendDataInfo, 'bgiIsesupervise', 0)
                        }
                    }
                    if (!this.sendDataInfo.dempBusgoodpriceList || !Array.isArray(this.sendDataInfo.dempBusgoodpriceList)
                        || this.sendDataInfo.dempBusgoodpriceList.length < 1) {
                        this.sendDataInfo.dempBusgoodpriceList = [];
                        this.priceResData.forEach((v) => {
                            this.sendDataInfo.dempBusgoodpriceList.push({
                                levleId: v.levleId,
                                levleDiscount: 0,
                                levlePrice: 0,
                                priceType: false,
                            });
                        });
                    } else {
                        this.sendDataInfo.dempBusgoodpriceList.forEach(v => v.priceType = v.priceType == 1 ? true : false)
                    }
                    if (this.dataActionBox.actionType == 1) {
                        this.showTabs = this.actionData.formData[0].jciName;
                        if (this.isQixie) { //器械
                            this.dataActionBox.boxTitle = this.componentType ? "编辑器械信息" : "编辑首营器械信息";  //false首营
                        } else {
                            this.dataActionBox.boxTitle = this.componentType ? "编辑商品信息" : "编辑首营商品信息";
                        }
                        if (this.sendDataInfo.validPeriod != '' && this.sendDataInfo.validPeriod != null) this.sendDataInfo.validPeriod = this.sendDataInfo.validPeriod.split('个月')[0]
                    }
                    if (this.dataActionBox.actionType == 7) {
                        this.showTabs = this.actionData.formData[0].jciName;
                        if (this.isQixie) { //器械
                            this.dataActionBox.boxTitle = this.componentType ? "新增器械信息" : "新增首营器械信息";  //false首营
                        } else {
                            this.dataActionBox.boxTitle = this.componentType ? "新增商品信息" : "新增首营商品信息";
                        }
                    }
                    if (this.dataActionBox.actionType == 3) {
                        if (this.isQixie) { //器械
                            this.dataActionBox.boxTitle = this.componentType ? "提交器械信息" : "提交首营器械信息";  //false首营
                        } else {
                            this.dataActionBox.boxTitle = this.componentType ? "提交商品信息" : "提交首营商品信息";
                        }
                        if (this.sendDataInfo.validPeriod != '') this.sendDataInfo.validPeriod = this.sendDataInfo.validPeriod.split('个月')[0]
                    }
                    if (this.dataActionBox.actionType == 4) {//审核
                        console.log("进入审核页面了")
                        console.log(this.componentType)
                        if (this.isQixie) { //器械
                            this.dataActionBox.boxTitle = this.componentType ? "器械信息审核" : "首营器械信息审核";  //false首营
                        } else {
                            this.dataActionBox.boxTitle = this.componentType ? "商品信息审核" : "首营商品信息审核";
                        }
                        this.taskData.auditState = 1;
                        this.taskData.auditRemark = "";
                        this.taskData.businessId = [oldData.ggmId];
                        if (this.sendDataInfo.validPeriod != '') this.sendDataInfo.validPeriod = this.sendDataInfo.validPeriod.split('个月')[0]
                    }
                    if (this.dataActionBox.actionType == 5) {
                        this.dataActionBox.boxTitle = this.isQixie ? "首营器械信息" : "首营商品信息";
                        if (this.isQixie) { //器械
                            this.dataActionBox.boxTitle = this.componentType ? "器械信息" : "首营器械信息";  //false首营
                        } else {
                            this.dataActionBox.boxTitle = this.componentType ? "商品信息" : "首营商品信息";
                        }
                        if (this.sendDataInfo.validPeriod != '') this.sendDataInfo.validPeriod = this.sendDataInfo.validPeriod.split('个月')[0]
                    }
                    if (this.dataActionBox.actionType == 2) {
                        var dataInfo = JSON.parse(JSON.stringify(oldData));
                        for (let key in dataInfo) {
                            this.$set(this.sendDataInfo, key, dataInfo[key])
                        }

                    }
                    if (this.dataActionBox.actionType == 9) {
                        var dataInfo = JSON.parse(JSON.stringify(oldData));
                        for (let key in dataInfo) {
                            if (key == 'fileNumber' || key == 'bgmCode') {
                                this.$set(this.sendDataInfo, key, "")
                            } else if (key == "dempBusgoodpriceList") {
                                this.$set(this.sendDataInfo, key, dataInfo[key])
                            } else if (key == "descibGoodLicenceAddList") {
                                this.$set(this.sendDataInfo, key, dataInfo[key])
                                // 初始化 isIntercept 和 isUsed 字段，如果为 null 则设置默认值 '1'
                                if (dataInfo[key]) {
                                    dataInfo[key].forEach(item => {
                                        if (item.isIntercept === null || item.isIntercept === undefined || item.isIntercept === "") {
                                            this.$set(item, 'isIntercept', "1");
                                        }
                                        if (item.isUsed === null || item.isUsed === undefined || item.isUsed === "") {
                                            this.$set(item, 'isUsed', "1");
                                        }
                                    })
                                }
                            } else {
                                this.$set(this.sendDataInfo, key, dataInfo[key])
                            }
                            this.$set(this.sendDataInfo, 'isCopy', 1)
                        }
                    }
                    if (this.sendDataInfo.stId != "" && this.sendDataInfo.stId != null) {
                        this.sendDataInfo.stId = Number(this.sendDataInfo.stId)
                    }
                }
                if (this.sendDataInfo.bgiType) {
                    this.seeTypeChange()
                }
            });

            // 药品类型0.药品1.器械2.其他
            if (/(器)/g.test(this.showTabs)) {
                this.sendDataInfo.goodType = 1;
            } else if (/(其他)/g.test(this.showTabs)) {
                this.sendDataInfo.goodType = 2;
            } else {
                this.sendDataInfo.goodType = 0;
            }
            if (this.isQixie == 1 && this.dataActionBox.actionType == 0) { //器械
                this.pushDefaultValue('sendDataInfo')
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$set(this.sendDataInfo, 'isDl', String(this.sendDataInfo['isDl'] || 0))
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.getType()
                    this.OCRResult(this.actionData.ocrResults || [])
                }, 16.7)
            });

        },
        //获取价格策略(新增)
        async getPriceList() {
            var responseData = await this.$http.getPriceStrategyGroup(this.token);
            if (responseData.status == 200) {
                this.priceResData = responseData.result;
            } else {
                this.$message({
                    message: "获取价格策略失败",
                    type: "error",
                });
                return false;
            }
        },
        changesmIntype() {
            this.licenseList.forEach(item => {
                this.$set(item, "isBT", 0)
                this.$set(item, "isKX", 0)
            })
            this.rulesList.forEach(item => {
                if (item['商品分类'] == this.sendDataInfo.bgiType) {
                    item['拦截证照'].forEach(items => {
                        var arr = items['证照名称'].split(",")
                        if (arr.length == 1) {
                            var flag = false
                            var flage = false
                            if (this.zzList.length > 0) {
                                this.zzList.forEach(item => {
                                    if (item == arr[0]) {
                                        flage = true
                                    }
                                })
                            }
                            if (!flage) {
                                this.zzList.push(arr[0])
                            }
                            this.licenseList.forEach(item => {
                                if (item.diName == arr[0]) {
                                    this.$set(item, "isBT", 1)
                                }
                            })
                            if (this.sendDataInfo.descibGoodLicenceAddList.length > 0) {
                                this.sendDataInfo.descibGoodLicenceAddList.forEach(item => {
                                    if (item.glTername == arr[0]) {
                                        flag = true
                                    }
                                })
                            }
                            if (!flag) {
                                this.sendDataInfo.descibGoodLicenceAddList.push({
                                    glTername: arr[0], //证照名称
                                    sliTername: "",
                                    glTernumber: "",//证照号
                                    glReoffice: "",
                                    glTervalidity: "",
                                    glRedate: "",
                                    uploadVoList: [], //附件
                                    lityId: arr[0],
                                    isIntercept: "1",
                                    isUsed: "1",
                                    remark: "", //备注
                                })
                                var index = this.sendDataInfo.descibGoodLicenceAddList.length - 1
                                this.lityChange(arr[0], index)
                            }
                        } else {
                            this.licenseList.forEach(item => {
                                arr.forEach(item1 => {
                                    if (item1 == item.diName) {
                                        this.$set(item, "isKX", 1)
                                    }
                                })
                            })

                        }

                    })
                }
            })
        },
        seeTypeChange() {
            if (this.licenseList) {
                this.licenseList.forEach(item => {
                    this.$set(item, "isBT", 0)
                    this.$set(item, "isKX", 0)
                })
                this.rulesList.forEach(item => {
                    if (item['单位类型'] == this.sendDataInfo.bgiType) {
                        item['拦截证照'].forEach(items => {
                            var arr = items['证照名称'].split(",")
                            if (arr.length == 1) {
                                this.licenseList.forEach(item => {
                                    if (item.diName == arr[0]) {
                                        this.$set(item, "isBT", 1)
                                    }
                                })
                            } else {
                                this.licenseList.forEach(item => {
                                    arr.forEach(item1 => {
                                        if (item1 == item.diName) {
                                            this.$set(item, "isKX", 1)
                                        }
                                    })
                                })

                            }
                        })
                    }
                })
            }
        },
        setzzList() {
            this.$http.getGoodLicenceRule().then(res => {
                this.rulesList = JSON.parse(res.result)
            })
        },
        //保存
        async sendDataAction(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let errorIndex = -1
                    this.sendDataInfo.descibGoodLicenceAddList.forEach((item, index) => {
                        // 统一处理假值，包括0转换为空字符串
                        item.glTervalidity = item.glTervalidity == 0 ? "" : item.glTervalidity
                        item.glRedate = item.glRedate == 0 ? "" : item.glRedate

                        // 检查有效期是否小于办证日期
                        if (item.glRedate && item.glTervalidity && item.glTervalidity < item.glRedate && errorIndex === -1) {
                            errorIndex = index
                            item.glTervalidity = 0.5  // 标记错误项
                        }
                    })

                    if (errorIndex !== -1) {
                        const errorMessage = `第${errorIndex + 1}行的${this.sendDataInfo.descibGoodLicenceAddList[errorIndex].glTername}的有效期不能小于办证日期`
                        this.$message.error(errorMessage)
                        return false
                    }
                    const params = {
                        formId: 11405,
                        descibGoodLicenceList: this.sendDataInfo.descibGoodLicenceAddList
                    }
                    params.bgiType = this.sendDataInfo.bgiType
                    var responseData = await this.$http.fromrulecheckGoodsLicense(params)
                    console.log(responseData);

                    if (responseData.status == 200) {
                        if (responseData.result.length > 0) {
                            this.dialogList = responseData.result
                            this.showStatus = this.dialogList.findIndex(item => item.level == 0)
                            this.showDialog = true
                        } else {
                            this.sub()
                        }
                    } else {
                        this.$message.error(responseData.message)
                    }
                    //   
                } else {
                    return this.$message({
                        message: "请完善商品信息",
                        type: "error",
                    });
                }
            });
        },
        showClose() {
            this.showDialog = false
            if (this.showStatus == -1) {
                this.sub()
            }
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), '提示', {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        async sub() {
            var flag = false
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            sendData.bgiSurgeryType = (this.bgiSurgeryTypeIds && this.bgiSurgeryTypeIds.length > 0) ? this.bgiSurgeryTypeIds.join(',') : "";
            sendData.dempBusgoodpriceList.forEach((item, index) => {
                if (item.priceType) {
                    if (item.levleDiscount < 0) {
                        this.$message({
                            message: "请填入合理折扣",
                            type: "error",
                        });
                        flag = true
                    } else {
                        item.priceType = 1
                    }
                } else {
                    if (item.levlePrice < 0) {
                        this.$message({
                            message: "请填入合理价格",
                            type: "error",
                        });
                        flag = true
                    } else {
                        item.priceType = 0
                    }
                }
                item.levlePrice = this.$common.getDecimalInfo(2, item.levlePrice)
            })
            if (flag) return
            if (this.sendDataInfo.validPeriod && this.sendDataInfo.validPeriod != '') {
                sendData.validPeriod = this.sendDataInfo.validPeriod + '个月';
            } else {
                sendData.validPeriod = ''
            }
            if (sendData.dempBusgoodpriceList && Array.isArray(sendData.dempBusgoodpriceList)) {
                sendData.dempBusgoodpriceList.forEach(v => v.priceType = v.priceType ? 1 : 0)
            }
            console.log('sendDatain', sendData);
            if (sendData.goodType == 2) {//其他传个固定的参数
                sendData.isGsp = 1
            }
            let responseData = ''
            if (this.actionData.type == '审核修改') {
                let params = {
                    auditAddDto: this.taskData,
                    update: sendData
                }
                responseData = await this.$http.getFirstauditModify(params)
                if (responseData.status == 200) {
                    this.init();
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    this.$emit("drawerCancel", true);
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } else {
                if (this.dataActionBox.actionType == 0 || this.dataActionBox.actionType == 7 || this.dataActionBox.actionType == 9) {

                    if (this.componentType) {
                        responseData = await this.$http.addBusinessGoods(sendData);
                    } else {
                        responseData = await this.$http.addFirstGoods(sendData);
                    }
                } else {
                    if (this.componentType) {
                        responseData = await this.$http.setBusinessGoods(sendData);
                    } else {
                        responseData = await this.$http.setFirstGoods(sendData);
                    }
                }
                if (responseData.status == 200) {
                    this.init();
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    // this.dataActionBox.showStatus = false
                    this.$emit("drawerCancel", true);
                    this.$refs["addpushlist"].resetFields();
                } else if (responseData.status == 300) {
                    this.$confirm(responseData.message + ", 是否继续新增?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(async () => {
                            this.sendDataInfo.state = 0
                            this.sub()
                        })
                        .catch(() => {
                            this.sendDataInfo.state = ''
                        });
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [14, 10, 9, 25, 11, 13, 5, 30, 39, 41, 42, 43, 58, 61, 62, 65, 70, 71],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
                // 药品类型0.药品1.器械2.其他
                if (/(器)/g.test(this.showTabs)) {
                    this.licenseList = this.dictionariesData.QXZZLX
                } else if (/(其他)/g.test(this.showTabs)) {
                    this.licenseList = this.dictionariesData.QTZZLX
                } else {
                    this.licenseList = this.dictionariesData.spzzlx
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取产品线列表
        async baseprolinequery() {
            let responseData = await this.$http.baseprolinequery({ prlName: "", bgiLineClass: "", page: 1, rows: 10000 });
            if (responseData.status == 200) {
                this.baseprolineList = responseData.result.list;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取所有可用库房列表
        async getAllStorageRoom() {
            let responseData = await this.$http.getGspStorageRoom();

            if (responseData.status == 200) {
                this.storageRoomList = responseData.result;
                // 修复条件判断：actionType == 0(新增), 4(审核), 7(复制新增) 时需要设置默认值
                if (this.storageRoomList.length != 0 && (this.dataActionBox.actionType == 0 || this.dataActionBox.actionType == 4 || this.dataActionBox.actionType == 7)) {
                    //赋个默认值,defaultValue的值过滤 可用库房列表 
                    console.log(this.tabForm, this.storageRoomList, "库房！！！！！！！")
                    this.tabForm[0].jurconfigform.forEach(item => {
                        if (item.entityField == 'stId') {
                            if (item.defaultValue !== "" && item.defaultValue != null) {
                                // 当前 stId 不是有效库房ID时才重新赋值（防止 filterMainFields 把 defaultValue 的库房名称写进了 stId）
                                let isValidId = this.storageRoomList.some(e => e.stId == this.sendDataInfo.stId)
                                if (!isValidId) {
                                    let matched = this.storageRoomList.find(e => e.stName == item.defaultValue)
                                    this.sendDataInfo.stId = matched ? matched.stId : this.storageRoomList[0].stId
                                }
                            } else {
                                this.getGoodStRule()
                            }
                        }
                    })
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getGoodStRule() {
            const res = await this.$http.getGoodStRule()
            if (res.status == 200) {
                if (res.result == null || res.result === "" || res.result == 1) {
                    let isValidId = this.storageRoomList.some(e => e.stId == this.sendDataInfo.stId)
                    if (!isValidId) {
                        this.sendDataInfo.stId = this.storageRoomList[0].stId
                    }
                } else {
                    let isValidId = this.storageRoomList.some(e => e.stId == this.sendDataInfo.stId)
                    if (!isValidId) {
                        this.sendDataInfo.stId = ""
                    }
                }
            }
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                    }
                    if (key.jurconfigform[index].entityField == 'stId' && key.jurconfigform[index].isShow == 0) {
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                    }
                }
            });
            var arr = [{ entityField: "descibGoodLicenceAddList" }, { entityField: "dempBusgoodpriceList" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            // 确保 radio 类型字段的默认值正确设置
            mainFormList[0].jurconfigform.forEach(item => {
                if (item.fieldType == 'radio' && item.entityField == 'bgiIsesupervise') {
                    // 如果配置中没有默认值，则设置为 0
                    if (this.sendDataInfo.bgiIsesupervise === undefined || this.sendDataInfo.bgiIsesupervise === '') {
                        this.$set(this.sendDataInfo, 'bgiIsesupervise', 0)
                    }
                }
            })
            mainFormList[1].jurconfigform.forEach(item => {
                if (item.fieldType == 'number') {
                    this.$set(this.addpushlist, item.entityField, 0)
                } else if (item.fieldType == 'search' && item.setField) {
                    var arr = item.setField.split(',')
                    arr.forEach(item2 => {
                        this.$set(this.addpushlist, item2, "")
                    })
                } else {
                    this.$set(this.addpushlist, item.entityField, "")
                }
            })
            const list = new Set()
            this.tabForm.forEach(item => {
                list.add(item.jciId)
            })
            const result = []
            Array.from(list).forEach(items => {
                result.push(this.tabForm[this.tabForm.findIndex(item => item.jciId == items)])
            })
            this.tabForm = result
        },
        async getQueryCodeClassifyaArr() {
            let params = { "codeClassify": 0 } // "编号分类0.商品1.供应商2.客户")
            let res = await this.$http.getQueryCodeClassify(params)
            console.log(res)
            this.codeClassify = res.result
        },
        async ruleChange() {
            const res = await this.$http.getLicenceNumberRule()
            if (res.status == 200) {
                if (res.result.ruleParam && res.result.isEnable == 1) {
                    this.ruleData = JSON.parse(res.result.ruleParam)
                    console.log(this.ruleData, "测试");

                } else {
                    this.ruleData = []
                }
            } else {
                this.$message.error(res.message)
            }
        },
        async getType() {
            const res = await this.$http.dictSurgeryqueryList({ surgeryName: "" })
            if (res.status == 200) {
                this.bgiSurgeryTypeList = res.result;
                if (this.dataActionBox.actionType != 0) {
                    let value1 = [];
                    if (this.bgiSurgeryTypeIds && this.bgiSurgeryTypeIds.length) {
                        const idSet = new Set(this.bgiSurgeryTypeIds.map(String));
                        this.bgiSurgeryTypeList.forEach(item => {
                            if (idSet.has(String(item.id))) {
                                value1.push(item.surgeryName);
                            }
                        });
                    }
                    this.obj.bgiSurgeryTypeNames = value1.join(',');
                }
            }
        },

        // 编号前缀相关方法
        // 打开编号前缀选择弹窗
        openCodePrefixDialog() {
            this.loadCodePrefixList();
            this.codePrefixDialogVisible = true;
        },

        // 获取编号前缀列表
        async loadCodePrefixList() {
            try {
                // 这里调用获取编号前缀的API
                const response = await this.$http.BusinessGoodQueryMaxCode();
                this.codePrefixList = response.result || [];


            } catch (error) {
                console.error('获取编号前缀列表失败:', error);
                this.$message.error('获取编号前缀列表失败');
                this.codePrefixList = [];
            }
        },

        // 选择编号前缀
        handleCodePrefixSelect(row) {
            this.selectedCodePrefix = row;
        },

        // 双击表格行处理
        handleRowDoubleClick(row) {
            this.selectedCodePrefix = row;
            this.confirmCodePrefix();
        },

        // 确认选择编号前缀
        confirmCodePrefix() {
            if (!this.selectedCodePrefix) {
                this.$message.warning('请选择一个编号前缀');
                return;
            }

            // 计算下一个编号：前缀 + (最大编号的数字部分 + 1)
            const prefix = this.selectedCodePrefix.pre;
            const maxCode = this.selectedCodePrefix.maxCode;
            const numberPart = maxCode.replace(prefix, '');
            const nextNumber = parseInt(numberPart) + 1;
            const nextCode = prefix + nextNumber.toString().padStart(numberPart.length, '0');

            // 将生成的编号赋值给bgmCode字段
            this.sendDataInfo.bgmCode = nextCode;

            // 关闭弹窗
            this.codePrefixDialogVisible = false;
            this.selectedCodePrefix = null;

            this.$message.success(`已生成编号：${nextCode}`);
        },
        //获取分类
        async categoryquery() {
            let responseData = await this.$http.categoryquery({});
            if (responseData.status == 200) {
                this.categoryList = []
                if (responseData.result.length > 0) {
                    this.categoryList = this.handleJurisdiction(responseData.result)
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value = { ...value }
                    value['id'] = value['id']
                    value['value'] = value['categoryName']
                    value['label'] = value['categoryName']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },
    },

    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.showTabs = this.actionData.formData[0].jciName;
        this.isQixie = /(器)/g.test(this.showTabs);
        this.$nextTick(async () => {
            this.openBox();
            this.getAllStorageRoom();
            this.isLoaded = true;
            //type 范围类型0.生产范围1.经营范围
            await this.getQueryScopeByType(0).then((res) => {
                this.$set(this.rangeObj, "p", res);
            });
            await this.getQueryScopeByType(1).then((res) => {
                this.$set(this.rangeObj, "m", res);
            });
            await this.getQueryScopeByTypeZhenLiao(2).then((res) => {
                this.$set(this.rangeObj, "z", res);
            });

            // rangeObj 加载完成后，如果是复制新增模式，转换字典字段
            if (this.dataActionBox.actionType == 7) {
                this.convertDictFieldsToId()
            }
        });
        this.getPartDictionariesData();
        this.baseprolinequery();
        this.setzzList()
        this.ruleChange()
        this.imgur();
        this.categoryquery()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 450px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.oldInput {
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 90%;
}

.oldDisabled {
    background-color: #f5f7fa;
}

#bgmRemarks {
    width: 100%;
}

#bgmRemarks ::v-deep .el-form-item__content {
    width: 80% !important;
}

#bgmRemarks ::v-deep .el-textarea__inner {
    width: 76% !important;
}

#bgiSurgeryType {
    width: 100%;
}

#bgiSurgeryType ::v-deep .el-form-item__content {
    width: 80% !important;
}

#bgiSurgeryType ::v-deep .el-textarea__inner {
    width: 76% !important;
}

::v-deep .upload-demo ul {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
}

::v-deep .upload-demo img {
    width: 30px;
    height: 30px;
    margin-left: 0px;
}

::v-deep .upload-demo .el-upload-list--picture .el-upload-list__item {
    width: 86px;
    height: 42px;
    padding: 5px 0px;
    padding-left: 5px;
}

::v-deep .el-upload-list__item-name {
    margin-right: 0;
    font-size: 13px;
}

::v-deep .el-upload-list__item .el-icon-close {
    top: 2px;
    right: 2px;
}

::v-deep .el-upload-list--picture .el-upload-list__item-status-label {
    width: 40px;
    height: 24px;
    right: -20px;
    top: -9px;
}

::v-deep
    .el-upload-list--picture
    .el-upload-list__item.is-success
    .el-upload-list__item-name {
    line-height: 30px;
}

::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    color: #333;
}

::v-deep
    .el-radio-button__orig-radio:disabled:checked
    + .el-radio-button__inner {
    background-color: #ccc;
}

::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    color: #333;
}

.view-warp {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
}

/* 全局 */
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 10px;
}

/* 视频预览 */
#view1,
#view2 {
    /* width: 400px; */
    height: 300px;
    border: 1px solid #000;
    margin-right: 5px;
}

/* 缩略图 */
#suoluetu {
    /* width: 100%; */
    /* height: 85px; */
    flex: 1;
    height: 300px;
    /* border: 1px solid #ccc; */
}

#suoluetu img {
    width: 100%;
    height: 300px;
    margin-right: 10px;
}

/* 操作按钮 */
#myactive {
    /* border: 1px solid yellowgreen; */
    margin-top: 10px;
    padding: 10px 5px;
}

/* 操作日志 */
#mylog {
    border: 1px solid black;
    padding: 10px;
    margin-top: 10px;
    overflow: auto;
}

.baseForm ::v-deep .el-form-item__content {
    margin-left: 124px !important;
}

.baseForm ::v-deep .el-form-item__label {
    width: 124px !important;
}

.xing {
    position: absolute;
    top: 0;
    left: 5px;
    font-size: 18px;
    font-weight: 800;
}

/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    list-style: none;
}

.image {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}
.image_label1 {
    padding: 5px 10px !important;
}

::v-deep .el-image__error {
    font-size: 7px;
}
</style>